var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ width: _vm.w, height: _vm.h }),on:{"touchmove":function($event){$event.preventDefault();}}},[_c('canvas',{staticClass:"canvas",attrs:{"id":_vm.uid,"data-uid":_vm.uid,"disabled":_vm.disabled}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-956e2342","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-signature/src/components/vueSignature.vue
// module id = null
// module chunks = 